
import { useLogos } from "@/hooks/useLogos";

export const AboutSection = () => {
  const { getLogoUrl } = useLogos();
  
  return (
    <div className="space-y-4">
      <div className="flex justify-center md:justify-start">
        <img 
          src={getLogoUrl('main_logo')}
          alt="AS2LAROUTE Logo"
          className="h-8 w-auto"
        />
      </div>
      <p className="text-sm text-white text-center md:text-left">
        Votre source d'actualités et d'informations sur l'univers automobile.
      </p>
    </div>
  );
};
